import React from 'react';
import './styles.scss';
import Header from '../../components/Header';
import Menu from '../../components/Menu';

const Terms: React.FC = () => {
  return (
    <>
      <Header />
      <div className="container about">
        <Menu />
        <div className="content">
          <h1>Termos e condições de uso</h1>
          <p>
            A aplicação Vein Risk (a partir deste momento/doravante designada
            'Aplicação') é um software destinado aos profissionais da Saúde
            (doravante denominada 'Utilizador'). Esta aplicação é propriedade de
            Les Laboratoires Servier, uma sociedade anônima simplificada com
            capital social de 34.590.852 euros, registrada no Registro Comercial
            e Empresarial de Nanterre com o número 085 480 796, cuja sede está
            localizada em 50, rue Carnot - 92284 Suresnes - França - Tel: 00 33
            (0) 1 55 72 60 00. O diretor de publicação é a empresa Servier SAS
            Representada pelo Dr. Olivier Laureau. Esta aplicação foi concebida
            e desenvolvida para os Les Laboratoires Servier by Servier
            International, uma sociedade de responsabilidade limitada com
            capital social de 7.995 euros, registrada no Registro Comercial e
            Empresarial de Nanterre com o número 312 357 865, cuja sede está
            localizada em 50, rue Carnot - 92284 Suresnes.
          </p>
          <p>CONTEÚDO DA APLICAÇÃO</p>
          <p>
            Como mencionado na seção SOBRE, a aplicação propõe uma avaliação da
            evolução da doença venosa crônica dos membros inferiores e apresenta
            imagens, assim como conselhos sobre o estilo de vida a adotar para
            auxiliar os profissionais de saúde na tomada na conscientização
            sobre a doença venosa crônica por parte dos doentes. A aplicação
            destina-se a profissionais de saúde e pode ser adquirida
            gratuitamente em lojas online abertas ao público, incluindo Apple
            Store e Google Play. No caso de uma pessoa não qualificada obter
            acesso à aplicação, esta pessoa será informada e aceitará que a
            utilização da aplicação não substitui de forma alguma, uma consulta
            com um médico, que é a única pessoa qualificada para formar um
            diagnóstico e fazer as recomendações adequadas. A aplicação não pode
            ser considerada uma opinião ou recomendação médica, e não deve ser
            considerada como uma ferramenta de diagnóstico ou terapêutica.
          </p>
          <p>LICENÇA E CANCELAMENTO</p>
          <p>
            Após o acordo dos presentes termos e condições de utilização, o
            utilizador receberá uma licença para utilização pessoal. Esta
            licença é estritamente limitada à utilização privada e não exclusiva
            do utilizador. O termo 'Utilização' refere-se ao acesso à aplicação,
            download, instalação ou qualquer outra ação relacionada com as
            funcionalidades propostas pela aplicação, dentro dos limites dos
            presentes termos e condições. Em particular, o utilizador não está
            autorizado a sublicenciar esta licença, a transferi-la, partilhá-la.
            Esta licença é válida até seu cancelamento. O cancelamento possui
            supremacia, sem formalidades, motivos particulares ou aviso prévio
            por qualquer das partes. Uma vez a licença do utilizador encerrada,
            o utilizador já não se encontra autorizado a utilizar a aplicação.
          </p>
          <p>PRIVACIDADE DE DADOS</p>
          <p>
            A empresa não tem acesso aos dados armazenados na aplicação pelo
            utilizador e não está autorizada a receber essa informação do
            utilizador.
          </p>
          <p>PROPRIEDADE INTELECTUAL</p>
          <p>
            O conteúdo da aplicação está protegido pelos direitos de propriedade
            intelectual (doravante designados 'DP intelectual') pertencentes à
            empresa ou a terceiros a quem a empresa concedeu as respectivas
            licenças de utilização. A licença gratuita concedida ao utilizador
            não pode ser entendida ou significar uma qualquer forma de renúncia
            da empresa na aplicação de todos os direitos de propriedade
            intelectual. O utilizador compromete-se a não interferir de forma
            alguma nos direitos de propriedade intelectual, nomeadamente,
            copiar, partilhar, modificar ou usar o conteúdo da aplicação sem a
            autorização prévia e expressa da empresa ou do proprietário dos DP
            intelectual em questão.
          </p>
          <p>RESPONSABILIDADE</p>
          <p>
            A aplicação foi desenvolvida com máximo rigor. No entanto, sem
            prejuízo de quaisquer disposições legais ou regulamentares que
            possam ser aplicáveis, não são fornecidas garantias quanto à
            funcionalidade e utilização da aplicação. Em particular, a empresa
            permite-se excluir todas as garantias e não assume qualquer
            responsabilidade quanto ao caráter exaustivo das informações
            fornecidas. O mesmo acontece com a falha na atualização da
            aplicação, o caráter não exaustivo e erros na aplicação. Além disso,
            a empresa não será responsável por qualquer dano direto ou indireto,
            tangível ou intangível ou perda de informação decorrente da
            utilização da aplicação, independentemente da sua natureza,
            incluindo, entre outros, danos corporais ou danos causados pelo mau
            funcionamento e/ou utilização indevida da aplicação pelo utilizador.
            CONTATO: Les Laboratoires Servier 50, rue Carnot, 92284 Suresnes
            Cedex. 01.55.72.60.00.
          </p>
          <p>APLICAÇÃO DE VERSÃO: v1.5 Data CGU: 29/11/2016</p>
        </div>
      </div>
    </>
  );
};

export default Terms;
